<app-main>
  <div class="stats">
    <h1>Correspondance OS</h1>
    <div
      style="margin-bottom: 16px; display: flex; justify-content: space-between"
    >
      <app-generic-create-button
        nameButton="correspondance OS"
        (click)="createButtonClicked()"
      ></app-generic-create-button>
      <app-generic-search-label
        [listElements]="listOsCorrespondance"
        [tableConfig]="tableConfig"
        endPoint="correspondance"
        (queryEmit)="loadOsCorrespondances($event)"
      ></app-generic-search-label>
    </div>
    <app-generic-table
      [config]="tableConfig"
      [rows]="listOsCorrespondance"
      [pageInformations]="pageInformations"
      (pageEmit)="pageEvent($event)"
      (updateEmit)="updateOsCorrespondance($event)"
      [updatebutton]="true"
      [isClickable]="true"
      [emitClickRow]="emitClickRow"
      [deletebutton]="true"
      (deleteEmit)="deleteOsCorrespondance($event)"
    ></app-generic-table>

    <h1>Incidents Correspondance OS</h1>
    @if(listIncidentOsCorrespondance.length > 0){
    <app-generic-table
      [config]="tableIncidentConfig"
      [rows]="listIncidentOsCorrespondance"
      [pageInformations]="pageIncidentInformations"
      (pageEmit)="pageIncidentEvent($event)"
      (updateEmit)="updateIncidentOsCorrespondance($event)"
      [updatebutton]="true"
      [isClickable]="true"
    ></app-generic-table>
    } @else {
      <span>Aucun incident de correspondance d'OS détecté</span>
    }
  </div>
</app-main>
<ngx-spinner
  bdColor="rgba(0,0,0,0.8)"
  size="medium"
  color="#fff"
  type="ball-spin-clockwise"
  [fullScreen]="true"
>
</ngx-spinner>
